export enum FeatureScope {
    Viewer = 'Viewer',
    Global = 'Global',
    Client = 'Client'
}
